export var AuthType;
(function (AuthType) {
    AuthType["AAD"] = "aad";
    AuthType["EncryptedToken"] = "encryptedtoken";
    AuthType["MasterKey"] = "masterkey";
    AuthType["ResourceToken"] = "resourcetoken";
    AuthType["ConnectionString"] = "connectionstring";
})(AuthType || (AuthType = {}));
